import MPanel from './MPanel.vue';

export { MPanel };
export default MPanel;
